/**
 * The maximum number of rows that can be displayed inside "Top X by Y" widgets.
 * We always grab the maximum number of rows and decide in the frontend how many of them should be displayed
 * based on the size of the widget.
 *
 * NOTE: this may be inefficient, but for such a small scale of data, the efficient implementation is a little bit
 * too cumbersome to do (we would need to send widget size data to  the backend, rate limit refresh events to avoid
 * flooding the backend when resizing, etc.)
 */
export const DEFAULT_RM_WIDGET_TOP_ROWS = 20;
